module.exports = __webpack_public_path__ + "static/media/public.jwt.3e2b7bd7.pem";